import React, { useMemo, useState, useCallback, FC, useEffect } from "react";
import { Card, Badge, CloseButton, Form, Row, Col } from "react-bootstrap";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";
import "./MultiTagDropdown.css";

type TreeNode = {
  label: string;
  value: string;
  children?: TreeNode[];
  checked?: boolean;
  expanded?: boolean;
  disabled?: boolean;
};

type MultiTagDropdownProps = {
  id: string;
  data: any;
  disabled?: boolean;
  className?: string;
  keepTreeOnSearch?: boolean;
  keepChildrenOnSearch?: boolean;
  keepOpenOnSelect?: boolean;
  inlineSearchInput?: boolean;
  popupMaxHeight?: number | string;
  onChange: (allValue:any) => void;
  defaultValue?: string[];
}

const MultiTagDropdown:FC<MultiTagDropdownProps> = ({
  id,
  data,
  disabled = false,
  className = "",
  keepTreeOnSearch = true,
  keepChildrenOnSearch = true,
  keepOpenOnSelect = true,
  inlineSearchInput = true,
  onChange,
  popupMaxHeight = 320,
}) => {
  

  const [treeData, setTreeData] = useState<TreeNode[]>([]);

  useEffect(()=>{
    setTreeData(data)
  },[data])

  const handleTreeChange = useCallback((currentNode:any, selectedNodes:any) => {
    onChange(selectedNodes)
  }, [onChange])


  // Convert popupMaxHeight to a CSS value
  const popupMaxHeightCss =
    typeof popupMaxHeight === "number" ? `${popupMaxHeight}px` : popupMaxHeight;

  return (
    <Form.Group className={`w-100 ${className} bootstrap-demo`} controlId={id}>
      <DropdownTreeSelect
        data={treeData}
        onChange={handleTreeChange as any}
        className="bootstrap-tree-select"
        disabled={disabled}
        showPartiallySelected={true}
        keepTreeOnSearch={keepTreeOnSearch}
        keepOpenOnSelect={keepOpenOnSelect}
        inlineSearchInput={false}
        clearSearchOnChange={true}
        mode="multiSelect"
      />

      {/* Width + popup sizing rules */}
      <style>{`
        /* Force the control to fill its Bootstrap column */
        .bootstrap-demo,
        .bootstrap-demo .bootstrap-tree-select,
        .bootstrap-demo .bootstrap-tree-select .dropdown,
        .bootstrap-demo .bootstrap-tree-select .dropdown-trigger,
        .bootstrap-demo .bootstrap-tree-select .search {
          width: 100%;
        }

        /* Make popup match trigger width and allow scrolling with a max height */
        .bootstrap-demo .bootstrap-tree-select .dropdown-content {
          width: 100%;
          left: 0;
          right: 0;
          max-height: ${popupMaxHeightCss};
          overflow: auto;
          z-index: 1056;
        }

        /* Optional: tidy look with Bootstrap */
        .bootstrap-demo .bootstrap-tree-select .tag { display: block; }
        .bootstrap-demo .bootstrap-tree-select .search {
          border: 1px solid var(--bs-border-color);
          border-radius: .375rem;
          padding: .25rem .5rem;
        }
      `}</style>
    </Form.Group>
  )
}

export default React.memo(MultiTagDropdown)